export default "__VITE_ASSET__BuD_RBuD__"